import { render, staticRenderFns } from "./UnChargeStatisManage.vue?vue&type=template&id=a795a744&"
import script from "./UnChargeStatisManage.vue?vue&type=script&lang=js&"
export * from "./UnChargeStatisManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports